/**
 * Placeholders de carregamento.
 *
 * Preferimos skeletons a spinners: eles preservam o layout final, então a
 * página não "pula" quando os dados chegam e a espera parece menor.
 */

export function Skeleton({ width, height, radius }: { width?: number | string; height?: number | string; radius?: number | string }) {
  return (
    <span
      className="skeleton"
      style={{
        display: 'block',
        width: width ?? '100%',
        height: height ?? 14,
        borderRadius: radius,
      }}
    />
  );
}

/** Grade de stat cards em carregamento — mesma métrica dos cards reais. */
export function SkeletonStats({ count = 4 }: { count?: number }) {
  return (
    <div className="stats-grid">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="skeleton skeleton-stat" style={{ animationDelay: `${i * 60}ms` }} />
      ))}
    </div>
  );
}

/** Linhas de tabela em carregamento, com larguras variadas para parecer real. */
export function SkeletonRows({ rows = 8, cols = 6 }: { rows?: number; cols?: number }) {
  const widths = ['70%', '85%', '45%', '60%', '78%', '52%', '66%', '40%'];
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={r}>
          {Array.from({ length: cols }, (_, c) => (
            <td key={c}>
              <Skeleton width={widths[(r + c) % widths.length]} height={12} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

/** Fallback de rota — usado no Suspense enquanto o chunk da página baixa. */
export function PageSkeleton() {
  return (
    <div className="ops-page page-fade">
      <header className="page-header">
        <div style={{ flex: 1, maxWidth: 340 }}>
          <Skeleton width="55%" height={26} radius={8} />
          <div style={{ height: 10 }} />
          <Skeleton width="85%" height={13} />
        </div>
      </header>
      <SkeletonStats count={4} />
      <div className="card">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} style={{ padding: '10px 0' }}>
            <Skeleton width={`${45 + ((i * 13) % 45)}%`} height={13} />
          </div>
        ))}
      </div>
    </div>
  );
}
